import { fireStatusUpdate } from '../../../../utils/CallbackUtils/index';
import { StatusTypes, Component, DropInPaymentsCommandNames } from '../../../../utils/CallbackUtils/constants';
import { ErrorTypes, Strings } from '../../strings';
import { CouponErrorText } from '../../../../utils/RioUtils/interfaces';
export var getSuccessMessage = function getSuccessMessage(isAutofilled, content) {
  return isAutofilled ? (content === null || content === void 0 ? void 0 : content.couponAutoFillSuccessText) || Strings.AUTOFILL_ADD_SUCCESS : (content === null || content === void 0 ? void 0 : content.couponSuccessText) || Strings.ADD_COUPON_SUCCESS;
};
export var addCouponToCart = function addCouponToCart(couponCode, addCoupon) {
  addCoupon(couponCode);
};
export var doAddCouponErrorLogging = function doAddCouponErrorLogging() {
  fireStatusUpdate([{
    status: StatusTypes.ERROR,
    command: DropInPaymentsCommandNames.ADD_COUPON,
    payload: {
      data: {
        component: Component.COUPON,
        errors: Strings.INVALID_CODE
      }
    }
  }], 'COUPON');

  /*
  Failure with a valid but non-applicable coupon                checkout_coupon_errors=nonapplicable_coupon
  Failure (invalid coupon, expired coupon, or any other error)  checkout_coupon_errors=invalid_coupon
   */
};

export var getCouponError = function getCouponError(isNotApplicable) {
  return isNotApplicable ? CouponErrorText.NON_APPLICABLE : CouponErrorText.INVALID;
};
export var getCouponValidationText = function getCouponValidationText(errorType, errorText) {
  if (errorType === ErrorTypes.REQUIRED) {
    return errorText || Strings.COUPON_REQUIRED;
  } else {
    return errorText || Strings.INVALID_CODE;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/views/App/helper.js
// module id = 3514
// module chunks = 11